import Photoviewer from "./Photoviewer";

export default Photoviewer;
